import React from 'react';

import { Alert, Button, Group, Modal, Stack, Text, Title } from '@mantine/core';
import { IconAlertSquare } from '@tabler/icons-react';
import useDeleteAthletePackageHold from 'hooks/athletePackageHold/useDeleteAthletePackageHold';
import { AthletePackageHold } from 'types';
import notificationHandler from 'utils/notifications';

const DeleteAthletePackageHoldModal = ({
  opened,
  athletePackageHold,
  handleClose,
}: {
  opened: boolean;
  handleClose: () => void;
  athletePackageHold?: AthletePackageHold;
}): JSX.Element => {
  const { mutate, isLoading } = useDeleteAthletePackageHold();
  const { successNotification, errorNotification } = notificationHandler();
  const handleDelete = (): void => {
    if (athletePackageHold) {
      mutate(athletePackageHold?.athletePackageHoldId, {
        onSuccess: () => {
          successNotification('Athlete package pause remove success', `Pause successfully removed.`);
          handleClose();
        },
        onError: error => {
          errorNotification('Athlete package pause remove failed', error.response?.data.message);
        },
      });
    }
  };
  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      size='lg'
      centered
      title={<Title order={4}>Remove Pause</Title>}
    >
      <Stack p='md'>
        <Text color='dimmed' size='sm'>
          Are you sure you want to remove this pause?
        </Text>
        <Text color='dimmed' size='sm' ta='center'>
          This action cannot be undone.
        </Text>
        <Alert variant='light' color='yellow' title='Attention' icon={<IconAlertSquare />}>
          Removing this pause will adjust invoice due dates and credit dispensations for this package and any
          renewals. The removal will fail if credits cannot be found for any checkins linked to this package
          or its renewals.
        </Alert>
      </Stack>
      <Group position='right' pt='md'>
        <Button variant='light' onClick={handleClose} size='xs' radius='md' disabled={isLoading}>
          Cancel
        </Button>
        <Button
          size='xs'
          radius='md'
          color='red'
          onClick={handleDelete}
          loading={isLoading}
          data-cy='holdsRemove'
        >
          Remove
        </Button>
      </Group>
    </Modal>
  );
};

export default DeleteAthletePackageHoldModal;
